/**
 * A primary key, out of whatever shape an endpoint chose to send it in.
 *
 * The same relation comes back three different ways across this API: a bare
 * numeric FK on one serializer, a nested object on another, and occasionally an
 * object wrapping another object. A query string built from the wrong one of
 * those reads `?patient=[object Object]` and the server answers 500, so the
 * conversion happens once, here, and anything that cannot be reduced to a
 * scalar comes back as null rather than as something that stringifies badly.
 */
export const toId = (value, depth = 0) => {
  if (value === null || value === undefined || depth > 3) return null;

  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  if (typeof value === "string") {
    const trimmed = value.trim();
    // "[object Object]" is an id that has already been stringified once by
    // mistake - it is not a key, and sending it on only moves the error.
    if (!trimmed || trimmed === "[object Object]" || trimmed === "undefined" || trimmed === "null") {
      return null;
    }
    return trimmed;
  }

  if (typeof value === "object") {
    return toId(value.id ?? value.pk ?? value.patient ?? null, depth + 1);
  }

  return null;
};

export default toId;
